import React, { Component } from "react";
import { withRouter } from "react-router";
import RectButton from "../ui/button/RectButton";

import Lottie from 'react-lottie';
import * as WriteMessageAim from '../assets/json/lottie/write-message.json';

import "./style.scss";

class Card extends Component {

   state = {
      view: "front",
      direction: 0,
      writing: false
   }

   constructor(props) {
      super(props)
      this.type = this.props.data.type;
   }

   favoriteToggle = (e) => {
      this.props.data.favorite = !this.props.data.favorite;
      if (this.props.onCardUpdate) this.props.onCardUpdate(this.props.data);
      this.forceUpdate();
      //implement request
      e.stopPropagation()
   }

   /*cardSelectionHandler = () => {
       if (this.props.onCardSelected) this.props.onCardSelected(this.props.data.id);
   }*/

   sendHandler = (e) => {
      console.log("sendHandler")
      this.props.history.push("/add-message")
      e.stopPropagation()
   }

   bulkSendHandler = (e) => {
      console.log("bulkSendHandler")
      this.props.history.push("/bulk-order")
      e.stopPropagation()
   }

   changeView(view, e) {
      let state = this.state;
      state.view = view;
      this.setState(state);
      if (e) e.stopPropagation();
   }

   imageLoaded = () => {
      let state = this.state;
      if (!this.frontImage) return;
      if (this.props.onLoadImage) this.props.onLoadImage();
      state.direction = this.frontImage.naturalWidth < this.frontImage.naturalHeight ? 1 : 0;
      this.setState(state);
   }

   componentDidMount() {
      if (this.frontImage) {
         if (this.frontImage.naturalWidth) this.imageLoaded();
         else this.frontImage.onload = this.imageLoaded;
         if (this.type === 1) this.frontImage.addEventListener("transitionend", this.transitionEndHandler);
         else if (this.type === 2) this.plane.addEventListener("transitionend", this.transitionEndHandler);
      }
   }

   componentWillUnmount() {
      if (this.frontImage) {
         this.frontImage.onload = null;
         this.frontImage.removeEventListener("transitionend", this.transitionEndHandler);
         this.plane.removeEventListener("transitionend", this.transitionEndHandler);
      }
   }

   transitionEndHandler = () => {
      // if ((this.type===1 && this.state.view !== "inside") || (this.type===2 && this.state.view !== "back")) this.setState({ writing: false })
   }

   clickHandler = () => {
      if (this.props.soft && this.props.onClick) this.props.onClick(this.props.data);
   }

   onMouseLeaveHandler = () => {
      if (this.state.view !== "front") this.setState({ view: "front" });
   }

   render() {
      let { name, price, favorite, frontImage, frontInsideImage, backImage } = this.props.data;

      price = parseFloat(price).toFixed(2);

      return (
         <>
            <div className={`card box ${this.props.expanded ? "expanded" : ""} ${this.props.soft ? "soft" : ""}`} onMouseEnter={(e)=> { if( this.type === 1 && window.innerWidth > 1024) this.changeView("inside", e); } } onClick={this.clickHandler} onMouseLeave={this.onMouseLeaveHandler}>
               {
                  this.props.soft ? null :
                     <div className="info-bar">
                        <div className={`favorite-bt ${favorite ? "favorite" : ""}`} ref={el => (this.favoriteBt = el)} onClick={this.favoriteToggle}></div>
                        <div className="name">{name}</div>
                        <div className="price">${price}</div>
                     </div>
               }
               <figure className="paper scene-3d">
                  <div className={`plane ${this.state.view} ${this.state.direction ? "v" : "h"}`} ref={el => (this.plane = el)}>
                     {this.type === 1 ? <img className="back-face" alt="Back" src={backImage} /> : null}
                     {this.type === 2 ?
                        <div className="back-face">
                           <Lottie options={{
                              loop: false,
                              autoplay: true,
                              animationData: WriteMessageAim.default,
                           }}
                              isStopped={!this.state.writing}
                              height="100%"
                              width="50%" />
                        </div>
                        : null}
                     {
                        this.type === 1 ?
                           <div className="inside-face">
                              <Lottie options={{
                                 loop: false,
                                 autoplay: true,
                                 animationData: WriteMessageAim.default,
                              }}
                                 isStopped={!this.state.writing}
                                 height="100%"
                                 width="50%" />
                           </div>
                           : null
                     }
                     <div className="front-face">
                        <img className="front-ouside" alt="Front" src={frontImage} ref={el => (this.frontImage = el)} />
                        <img className="front-inside" alt="Front Inside" src={frontInsideImage} />
                     </div>
                  </div>
               </figure>
               {
                  this.props.soft ? null :
                     <div className="actions">
                        <ul>
                           <li className={`uh ${this.state.view === "front" ? "active" : ""}`} onClick={(e) => { this.changeView("front", e) }}>Front</li>
                           {this.type === 1 ? <li className={this.state.view === "inside" ? "active" : ""} onClick={(e) => { this.changeView("inside", e); if (this.type === 1) this.setState({ writing: true }) }}>Inside</li> : null}
                           <li className={this.state.view === "back" ? "active" : ""} onClick={(e) => { this.changeView("back", e); if (this.type === 2) this.setState({ writing: true }) }}>Back</li>
                        </ul>
                        <div className="buttons">
                           <RectButton text="SEND" onClick={this.sendHandler} />
                           <RectButton text="BULK SEND" onClick={this.bulkSendHandler} />
                        </div>
                     </div>
               }

            </div>
         </>
      )
   }
}

export default withRouter(Card);